import { withStyles } from "@material-ui/core";
import StyledToolTipWithScroll from "../../../../../../common/StyledToolTipWithScroll";
const styles = (theme) => ({
  rowContainer: {
    display: "flex",
    flexDirection: "column",
    minWidth: 82,
    marginBottom: 4,
  },
  label: {
    fontWeight: 600,
    fontSize: 10,
    marginBottom: -8,
    color: theme.iconColor,
  },
  value: {
    fontWeight: 700,
    fontSize: 12,
    textTransform: "uppercase",
    color: theme.TextColor,
    lineHeight: 1,
    marginTop: 5,
    maxWidth: 60,
  },
  statusCodeValue: {
    wordWrap: "break-word",
    color: "#FA5C64",
  },
});
const PopupFieldRenderer = ({
  label,
  value,
  rowClassName,
  labelClassName,
  valueClassName,
  statusCodeValue,
  statusCodeTooltip = null,
  classes,
}) => {
  return (
    <div
      className={`${classes.rowContainer} ${rowClassName ? rowClassName : ""}`}
    >
      <span
        className={`${classes.label} ${labelClassName ? labelClassName : ""}`}
      >
        {label}
      </span>
      <span
        className={`${classes.value} ${valueClassName ? valueClassName : ""}`}
      >
        {value}
        {statusCodeValue && (
          <StyledToolTipWithScroll title={statusCodeTooltip}>
            <span className={classes.statusCodeValue}> ({statusCodeValue})</span>
          </StyledToolTipWithScroll>
        )}
      </span>
    </div>
  );
};

export default withStyles(styles)(PopupFieldRenderer);
